import { useState, useRef } from "react";
import Resume from "./components/Resume";
import AboutMe from "./components/AboutMe";
import Projects from "./components/Projects";
import NavBar from "./components/NavBar";
import ContactForm from "./components/ContactForm";

export default function App() {
  const [open, setOpen] = useState("home");
  const [openContactForm, setOpenContactForm] = useState(false);
  const contactFormRef = useRef(null);

  function handleNavigation(page) {
    setOpen(page);
  }

  function handleContactClick() {
    setOpenContactForm((curr) => !curr);
    if (!openContactForm) {
      setTimeout(() => {
        contactFormRef.current.scrollIntoView({ behavior: "smooth" });
      }, 500);
    }
  }

  return (
    <div className="Container">
      <header className="App-header">
        <NavBar onNavigate={handleNavigation} isSelected={open} />
      </header>

      <main>
        {open === "home" && <AboutMe></AboutMe>}
        {open === "resume" && <Resume />}
        {open === "projects" && <Projects />}
      </main>
      {open === "home" && (
        <footer>
          <div className="centerContactHeading">
            <h1
              className={`contactHeading ${openContactForm ? "open" : ""}`}
              onClick={handleContactClick}
            >
              Contact Me
            </h1>
          </div>
          <ContactForm
            isOpen={openContactForm}
            contactFormRef={contactFormRef}
          />
        </footer>
      )}
    </div>
  );
}
